// extracted by mini-css-extract-plugin
export default {"files":"UploadComponent_files__FiFXI","link":"UploadComponent_link__rOCj6"};